(ns ui.sync.event
  (:require
   [re-frame.core :as rf]))

;; Event id that Sente backend pushes. Must match backend payload.
(def sync-core-entities-event-id :sync/sync-core-entities)

(def core-entity-types
  #{:entity.type/tenant
    :entity.type/account
    :entity.type/pipeline
    :entity.type/opportunity-stage
    :entity.type/sales-opportunity-stage
    :entity.type/exit-opportunity-stage})

(def root-path [::sync :core-entities])
(def entities-path (conj root-path :entities))
(def by-type-path (conj root-path :by-type))

(rf/reg-event-db
 sync-core-entities-event-id
 (fn [db [_ payload]]
   (let [entities (or (:entities payload) [])
         entities-by-id (->> entities
                             (filter (fn [e]
                                       (contains? core-entity-types (:entity/type e))))
                             (map (fn [e]
                                    [(:db/id e) e]))
                             (into {}))
         by-type (->> entities-by-id
                      vals
                      (group-by :entity/type))]
     (-> db
         (assoc-in entities-path entities-by-id)
         (assoc-in by-type-path by-type)))))
